export default "__VITE_ASSET__ROvPlw1K__"